import Joi from 'joi';

const fullName = Joi.string().trim().min(2).max(120).required().messages({
  'any.required': 'الاسم الكامل مطلوب',
  'string.empty': 'الاسم الكامل مطلوب',
  'string.min': 'الاسم الكامل قصير جداً'
});

const username = Joi.string()
  .trim()
  .lowercase()
  .min(3)
  .max(40)
  .pattern(/^[a-z0-9_.-]+$/)
  .required()
  .messages({
    'any.required': 'اسم المستخدم مطلوب',
    'string.empty': 'اسم المستخدم مطلوب',
    'string.min': 'اسم المستخدم 3 أحرف على الأقل',
    'string.pattern.base': 'يقبل حروف لاتينية صغيرة وأرقام و . _ - فقط'
  });

const email = Joi.string()
  .trim()
  .email({ tlds: { allow: false } })
  .allow('', null)
  .messages({
    'string.email': 'صيغة البريد غير صحيحة (مثال: name@example.com)'
  });

const phone = Joi.string()
  .trim()
  .pattern(/^[0-9+\-\s]{6,20}$/)
  .allow('', null)
  .messages({
    'string.pattern.base': 'رقم الهاتف غير صالح (أرقام فقط، 6-20 خانة)'
  });

const roleId = Joi.string().required().messages({
  'any.required': 'الدور مطلوب',
  'string.empty': 'الدور مطلوب'
});

const status = Joi.string().valid('active', 'inactive');

const password = Joi.string()
  .min(8)
  .max(128)
  .pattern(/(?=.*[a-zA-Z])(?=.*[0-9])/)
  .required()
  .messages({
    'any.required': 'كلمة المرور مطلوبة',
    'string.empty': 'كلمة المرور مطلوبة',
    'string.min': 'كلمة المرور 8 أحرف على الأقل',
    'string.pattern.base': 'يجب أن تحتوي على حروف وأرقام'
  });

const permissions = Joi.array().items(Joi.string()).default([]);
const permissionsMode = Joi.string().valid('role', 'custom').default('role');
const assignedCashboxId = Joi.string().allow('', null);

export const createUserSchema = Joi.object({
  fullName,
  username,
  email,
  phone,
  roleId,
  assignedCashboxId,
  status,
  password,
  permissionsMode,
  permissions
});

export const editUserSchema = Joi.object({
  fullName,
  username,
  email,
  phone,
  roleId,
  assignedCashboxId,
  status,
  password: Joi.string().allow('', null),
  permissionsMode,
  permissions
});
